<template>
  <div id="recipeSearchList">
    <div class="search_header">
      <search :readonly="true"></search>
      <searchCriteria :ageKey="ageSeleKey" :ageList="babyDayList" :tapId="tapId"
                      @handleAgeKey="handleAgeKey" @handleSelect="handleSelect"></searchCriteria>
    </div>

    <div class="search-main">
      <van-list
          v-if="!showEmpty"
          v-model="loading"
          :finished="finished"
          finished-text=""
          @load="onLoad"
      >
        <listItem :recipesList="recipesList"></listItem>
        <template #finished>
          <img
              class="icon"
              src="@/assets/images/expertsView/pentagram.png"
              style="width: 9px"
          />
          我们会加油更新的 么么哒~
          <img
              class="icon"
              src="@/assets/images/expertsView/pentagram.png"
              style="width: 9px"
          />
        </template>
      </van-list>
      <emptyList v-if="showEmpty" :empType="2"></emptyList>
    </div>

  </div>

</template>

<script>
import {initClassTop, setClassTop} from "@/assets/js/common"
import search from "@/components/contents/babyFeeding/search";
import searchCriteria from "@/components/contents/babyFeeding/search/searchCriteria";
import listItem from "@/components/contents/babyFeeding/recipes/listItem"
import mixins from "@/minxs/babyFeeding"
// 数据为空组件
import emptyList from "@/components/contents/babyFeeding/recipes/emptyList.vue";
import Api from "@/utils/axiosApi/babyFeedingApi";
import {BuiedPointClick_Fn, Exposurer_feeding_Fn} from "@assets/js/BuriedPointEvent";
// 数据为空组件

export default {
  name: "recipeSearchList",
  mixins: [mixins],
  data() {
    return {
      babyDayList: [],
      tapId: 5,
      ageSeleKey: [0],
      babyFeedYue: {},
      //用户信息
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      lebalObj: {
        nameOne: '按月龄',
        nameTwo: '全部'
      },
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.commit('plusIncludes', 'recipeSearchList')
      vm.$store.commit('deleteDYIncludes', 'babyFeedDetails')
    })
  },
  activated() {
    setClassTop('search-main')
    this.$store.commit('deleteDYIncludes', 'searchResultsPage')
  },
  beforeRouteLeave(to, from, next) {
    initClassTop('search-main')
    next();
  },
  mounted() {
    Exposurer_feeding_Fn.observe('xmhh5_bbsp_allpageview', '.baby_feed_Index', false, {
      xmhh5_bbsp_pagename: '食谱查询',
      xmhh5_bbsp_monthage: this.babyFeedYue?.name || "",
      xmhh5_bbsp_title: ""
    })
  },
  async created() {
    sessionStorage.removeItem('player')
    this.babyFeedYue = JSON.parse(localStorage.getItem('babyFeedYue')) || {}
    await this.getTagByType()
    // if (this.$route.params.id) this.tapId = Number(this.$route.params.id)
    // this.ageSeleKey = [Number(this.$route.params.id)]
    await this.getBabyFeedList({
      ...this.setTypeKey(this.tapId, this.ageSeleKey)
    })
  },
  methods: {
    // 设置属性key
    setTypeKey(key, value) {
      console.log(key, value, 'setTypeKey')
      let obj = {}
      let arr = value.filter(item => item)
      console.log(arr)
      switch (key) {
        case 5:
          obj['forAgeIds'] = arr
          break;
        case 6:
          obj['forDiseaseIds'] = arr
          break;
        case 7:
          obj['forNutritionIds'] = arr
          break;
        case 8:
          obj['forEffectIds'] = arr
          break;
        case 9:
          obj['forSeasonIds'] = arr
          break;
        default:
          obj['forAgeIds'] = [key]
      }
      return obj
    },
    // 选择二级有变化
    handleAgeKey(value) {
      console.log(value, this.tapId, 'value')
      this.lebalObj.nameTwo = value.item.name
      this.ageSeleKey = value.ageSeleKey
      this.pageNum = 1
      this.setBuied()
      this.getBabyFeedList({
        ...this.setTypeKey(this.tapId, value.ageSeleKey)
      })
    },
    // 点击一级标签更改二级标签
    handleSelect(item) {
      console.log(item, '&&&&&&&&&&&&&')
      // this.ageSeleKey = []
      this.tapId = item.id
      this.lebalObj.nameOne = item.title
      this.lebalObj.nameTwo = '全部'
      this.getTagByType()
      this.pageNum = 1
      this.setBuied()
      this.getBabyFeedList({
        ...this.setTypeKey(this.tapId, this.ageSeleKey)
      })
    },
    setBuied() {
      BuiedPointClick_Fn('xmhh5_bbsp_spcx_click', {
        xmhh5_bbsp_classification1: this.lebalObj.nameOne,
        xmhh5_bbsp_classification2: this.lebalObj.nameTwo,
        xmhh5_bbsp_monthage: this.babyFeedYue?.name
      })
    },
    getTagByType() {
      Api.tagByType({
        type: this.tapId
      }, res => {
        if (res.code == "200") {
          this.babyDayList = [{name: '全部', id: 0}, ...res.data];
        }
      });
    },
    onLoad() {
      setTimeout(() => {
        if (this.recipesList.length) {
          if (this.total > this.recipesList.length) {
            this.pageNum = this.pageNum + 1
            console.log(this.tapId)
            this.getBabyFeedList({
              ...this.setTypeKey(this.tapId, this.ageSeleKey)
            })
          } else {
            this.finished = true
          }
        }
      }, 500)
    }
  },

  components: {
    search,
    searchCriteria,
    listItem,
    emptyList
  }
}
</script>

<style lang="less" scoped>
#recipeSearchList {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #fff;
  display: flex;
  flex-direction: column;

  ::v-deep.van-loading {
    background: #fff;
  }

  ::v-deep.van-list__finished-text {
    background: #fff;
  }

  .search-main {
    //flex: 1;
    height: calc(100vh - 167px);
    flex-grow: 0;
    flex-shrink: 0;
    overflow: scroll;
  }
}
</style>